import React from "react";
import Box from "@mui/material/Box";

// Define a type for the props
interface GreyDetailBoxProps {
  title: string;
  amount: string;
  deductible: string;
}

function GreyDetailBox(props: GreyDetailBoxProps) {
  const { title, amount, deductible } = props;

  return (
    <Box
      padding="24px"
      display="flex"
      flexDirection="column"
      gap="8px"
      sx={{ background: "#F4F3FF" }}
    >
      <p style={{ fontSize: "12px" }}>{title}</p>
      <h4>{amount}</h4>
      <p style={{ fontSize: "12px" }}>Deductible: {deductible}</p>
    </Box>
  );
}

export default GreyDetailBox;
